import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Challenge from './components/challenge';
import Selector from './components/selector';
import methods from './methods.js';
import './two-factor-auth.scss';

const TwoFactorAuth = ({
  savedMethod,
  email,
  phone,
  returnUrl
}) =>
{
  const [method, setMethod] = useState(savedMethod);
  const isIFrame = window.self !== window.top;

  const close = () =>
  {
    if (!isIFrame) return;

    window.parent.document.getElementById('id2faChallenge').style.display = 'none';
    window.parent.document.getElementsByTagName('BODY')[0].style.overflow = 'auto';
  };

  useEffect(() =>
  {
    if (!window.frameElement) return;

    window.frameElement.style.height = `${window.document.body.offsetHeight + 16}px`;
    window.document.body.style.overflow = 'hidden';
  });

  if (method === methods.UNDEFINED)
  {
    if (isIFrame)
    {
      return (
        <Selector
          setMethod={setMethod}
          email={email}
          phone={phone}
          close={close}
          returnUrl={returnUrl}
          isIFrame
        />
      );
    }
    return (
      <div id="id2faChallenge" className="-wa-2fa-challenge-page">
        <div className="-wa-2fa-challenge-page-shade" />
        <div className="-wa-2fa-challenge-page-frame">
          <Selector
            setMethod={setMethod}
            email={email}
            phone={phone}
            close={close}
            returnUrl={returnUrl}
            isIFrame={false}
          />
        </div>
      </div>
    );
  }

  if (isIFrame)
  {
    return (
      <Challenge
        method={method}
        setMethod={setMethod}
        email={email}
        phone={phone}
        close={close}
        returnUrl={returnUrl}
        isIFrame
      />
    );
  }
  return (
    <div id="id2faChallenge" className="-wa-2fa-challenge-page">
      <div className="-wa-2fa-challenge-page-shade" />
      <div className="-wa-2fa-challenge-page-frame">
        <Challenge
          method={method}
          setMethod={setMethod}
          email={email}
          phone={phone}
          close={close}
          returnUrl={returnUrl}
          isIFrame={false}
        />
      </div>
    </div>
  );
};

TwoFactorAuth.propTypes =
{
  savedMethod: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  returnUrl: PropTypes.string
};

TwoFactorAuth.defaultProps =
  {
    returnUrl: null
  };

export default TwoFactorAuth;